// @ts-ignore
export default function (value){
    if(!value || !value.name || !value.lastname) return;
    let name = value.name[0];
    let lastname = value.lastname[0];
    return name+lastname;
}